import { render, staticRenderFns } from "./Fetch.vue?vue&type=template&id=4e83ccfc&scoped=true&"
import script from "./Fetch.vue?vue&type=script&lang=js&"
export * from "./Fetch.vue?vue&type=script&lang=js&"
import style0 from "./Fetch.vue?vue&type=style&index=0&id=4e83ccfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83ccfc",
  null
  
)

export default component.exports